import React, { useState } from 'react';
import Layout from '../../layout/Layout';
import { Link } from 'react-router-dom';
import { Input, Button, Snackbar, TooltipTrigger } from '@bcmi-labs/react-components';
import { Trans, useTranslation } from 'react-i18next';
import { useForm, Controller } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import { useLocation } from 'react-router-dom';

import authService from '../../../auth/authService';
import AlertBox from '../../common/AlertBox';
import InfoIcon from '../../common/InfoIcon';

import './Recover.scss';

const Recover = () => {
  const { t } = useTranslation('recover');
  const location = useLocation();

  const urlParams = new URLSearchParams(location.search);
  const isChild = urlParams.get('isChild') === 'true';

  const { handleSubmit, errors, control, formState } = useForm({
    mode: 'onBlur',
  });
  const [error, setError] = useState('');
  const [showSuccessToast, setShowSuccessToast] = useState(false);
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  const onRecoverCallback = (err) => {
    setLoading(false);
    setShowSuccessToast(false);
    if (err) {
      setError(t(err.code));
    } else {
      setShowSuccessToast(true);
    }
  };

  const onSubmit = (data) => {
    setLoading(true);
    setShowSuccessToast(false);
    setError('');
    authService.resetPasswordRequest(data.email, onRecoverCallback);
  };

  const onChildSubmit = async (data) => {
    setLoading(true);
    setShowSuccessToast(false);
    setError('');
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/users/v1/children/help`, {
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
          'Content-Type': 'application/json',
        },
      });
      if (response.ok) {
        setShowSuccessToast(true);
      } else {
        setError(t('recover:childError'));
      }
    } catch (e) {
      setError(t('recover:childError'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout onBack={() => history.push('/login')} isChild={!!isChild}>
      <section className="recover">
        <h1 className="arduino-typography-large">{t('recover:title')}</h1>
        <p className="description">{isChild ? t('recover:childDescription') : t('recover:description')}</p>
        {isChild ? (
          <form onSubmit={handleSubmit(onChildSubmit)} noValidate>
            <div className="form-row">
              <Controller
                as={Input}
                name="username"
                control={control}
                defaultValue=""
                label={t('recover:yourUsername')}
                error={errors.username && errors.username.message}
                rules={{
                  required: t('recover:fieldRequired'),
                }}
                isRequired
              />
              <div className="tooltip-row-wrapper">
                <TooltipTrigger
                  TriggerElement={
                    <div>
                      <InfoIcon />
                    </div>
                  }
                  className="username-popover"
                  tooltipPlacement="top-start"
                  tooltipStrategy="absolute"
                  tooltipType={'popover'}
                >
                  {isChild ? t('recover:childTooltip') : t('recover:tooltip')}
                </TooltipTrigger>
              </div>
            </div>
            <Controller
              as={Input}
              name="parent_email"
              control={control}
              defaultValue=""
              label={isChild ? t('recover:parentEmailLabel') : t('recover:emailLabel')}
              error={errors.parent_email && errors.parent_email.message}
              rules={{
                required: t('recover:fieldRequired'),
                pattern: {
                  value: /(^$|^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$)/,
                  message: t('recover:emailInvalid'),
                },
              }}
              isRequired
            />
            {error ? <AlertBox message={error} /> : null}
            <Button type="submit" loading={loading} isDisabled={!formState.isValid}>
              {t('recover:submitText')}
            </Button>
          </form>
        ) : (
          <form onSubmit={handleSubmit(onSubmit)} noValidate>
            <Controller
              as={Input}
              name="email"
              control={control}
              defaultValue=""
              label={t('recover:emailLabel')}
              error={errors.email && errors.email.message}
              rules={{
                required: t('recover:fieldRequired'),
                pattern: {
                  value: /(^$|^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$)/,
                  message: t('recover:emailInvalid'),
                },
              }}
              isRequired
            />
            {error ? <AlertBox message={error} /> : null}
            <Button type="submit" loading={loading} isDisabled={!formState.isValid}>
              {t('recover:submitText')}
            </Button>
          </form>
        )}
        {isChild ? null : (
          <div className="or-signin">
            <Trans i18nKey="recover:orSignin">
              Or <Link to="/sign-in">sign in</Link> instead
            </Trans>
          </div>
        )}
        <Snackbar
          message={isChild ? t('recover:emailSentToParent') : t('recover:emailSent')}
          isOpen={showSuccessToast}
          className="no-white-space"
          onClose={() => setShowSuccessToast(false)}
        ></Snackbar>
        <div className="spacer"></div>
      </section>
    </Layout>
  );
};

export default Recover;
